import * as types from './types';
import { IMbrPolicy } from '@src/pages/Precision/MbrPolicy/types';
import update from 'immutability-helper';

interface IState {
  policies: IMbrPolicy[];
  loading: boolean;
}

const initialState: IState = {
  policies: [],
  loading: false,
};

const reducerMap: {
  [key in keyof typeof types]?: (
    state: IState,
    action: Partial<{ type: keyof typeof types }>,
  ) => IState;
} = Object.create(null);

reducerMap[types.SET_DATA] = (_, action) => ({
  ...initialState,
  ...action.data,
});

reducerMap[types.TOGGLE_LOADING] = (state, action) =>
  update(state, {
    loading: { $set: action.status },
  });

export default (state = initialState, action) =>
  reducerMap[action.type] ? reducerMap[action.type](state, action) : state;
